<template>
    <section class="dashboard">
        <b-row>
            <template v-if="busy">
                <b-col cols="12" class="db-col">
                    <CenteredMessage :spinner="true">Lädt...</CenteredMessage>
                </b-col>
            </template>
            <template v-else>
                <b-col cols="4" v-for="index in 3" :key="index" class="db-col">
                    <template v-if="findWidget(index)">
                        <ConcreteWidget
                            :widget="findWidget(index)"
                            class="db-widget"
                            :updated="updated"
                            :rank="index"
                            @remove="removeWidget"
                        />
                    </template>
                    <template v-else>
                        <DefaultWidget
                            class="db-widget"
                            :updated="updated"
                            :rank="index"
                            @update="addWidget"
                        />
                    </template>
                </b-col>
            </template>
        </b-row>
    </section>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Toaster from "@/mixins/Toaster/Toaster";
import DefaultWidget from "@/components/Widgets/DefaultWidget";
import ConcreteWidget from "@/components/Widgets/ConcreteWidget";
import CenteredMessage from "@/components/CenteredMessage/CenteredMessage";

const WidgetApi = ApiFactory.get("widgets");

import "./Dashboard.scss";

export default {
    name: "Dashboard",
    mixins: [Toaster],
    components: {
        DefaultWidget,
        ConcreteWidget,
        CenteredMessage
    },
    data() {
        return {
            widgets: [],
            updated: true,
            busy: false
        };
    },
    created() {
        this.fetch();
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await WidgetApi.get();
            if (response.ok) {
                if (response.json.collection) {
                    this.widgets = response.json.collection;
                }
            }
            this.busy = false;
        },
        async addWidget(id, rank) {
            const response = await WidgetApi.addWidget(id, rank);
            if (response.ok) {
                const insert = response.json.insert;
                if (insert) {
                    this.widgets.push(insert);
                } else {
                    this.makeToast(
                        "Probleme mit Widget",
                        "Das Widget funktioniert nicht korrekt und wird deshalb abgeschaltet",
                        "danger"
                    );
                    this.refreshWidgets();
                }
            } else {
                this.refreshWidgets();
            }
        },
        async removeWidget(id) {
            const response = await WidgetApi.removeWidget(id);
            if (response.ok) {
                this.widgets = this.widgets.filter(item => item.rel_id !== id);
            } else {
                this.refreshWidgets();
            }
        },
        findWidget(rank) {
            if (this.widgets) {
                var result = this.widgets.filter(item => item.rank === rank);
                if (result.length > 0) {
                    return result[0];
                }
            }
            return null;
        },
        refreshWidgets() {
            this.updated = !this.updated;
        }
    }
};
</script>